import NoticeIcon from 'assets/icons/notice-yellow-icon.svg';
import { IS_PAYTO_CONFIG_DISABLE } from 'config';
import {
  DESKTOP_MIN_WIDTH,
  HHMT_ADD_TRANSACTION_PAYMENT_METHODS,
  METHOD_PAYTO,
  REMOX_ADD_TRANSACTION_PAYMENT_METHODS,
} from 'constants';
import { FX_ADD_TRANSACTION_PAYMENT_METHOD_NAME } from 'constants/fx';
import useFxAddTransaction from 'hooks/fx/useFxAddTransaction';
import useFxFormAddTransactionStore from 'hooks/fx/useFxFormAddTransactionStore';
import useCommonStore from 'hooks/useCommonStore';
import useLang from 'hooks/useLang';
import useTheme from 'hooks/useTheme';
import { isArray, isEmpty } from 'lodash';
import { Fragment } from 'react';
import styled from 'styled-components';
import { paragraphMixin } from 'styles';
import { DescValidation } from '../PickupDate';
import PaymentMethodItem from './PaymentMethodItem';

const PaymentMethodsGrid = ({
  information,
  setInformation,
  validation,
  setValidation,
  informationChangeBackup,
  setInformationChangeBackup,
  setOpenDiscountImportantPopup,
  setOpenFxPaymentMethodOnChangePopup,
  paymentMethodCache,
  isSelectRequired,
}) => {
  const { t } = useLang();
  const { isHHMTTheme } = useTheme();

  const { paytoAccountsAgreement } = useCommonStore();
  const { getPaymentAmountLimit } = useFxFormAddTransactionStore();
  const { isFxAsGuest, getPayLimitRanger } = useFxAddTransaction();

  const PAYMENT_METHODS = isFxAsGuest
    ? isHHMTTheme
      ? HHMT_ADD_TRANSACTION_PAYMENT_METHODS.slice(1)
      : REMOX_ADD_TRANSACTION_PAYMENT_METHODS.slice(1)
    : isHHMTTheme
    ? isEmpty(paytoAccountsAgreement)
      ? IS_PAYTO_CONFIG_DISABLE
        ? HHMT_ADD_TRANSACTION_PAYMENT_METHODS.slice(1)
        : HHMT_ADD_TRANSACTION_PAYMENT_METHODS
      : HHMT_ADD_TRANSACTION_PAYMENT_METHODS
    : isEmpty(paytoAccountsAgreement)
    ? IS_PAYTO_CONFIG_DISABLE
      ? REMOX_ADD_TRANSACTION_PAYMENT_METHODS.slice(1)
      : REMOX_ADD_TRANSACTION_PAYMENT_METHODS
    : HHMT_ADD_TRANSACTION_PAYMENT_METHODS;

  const isPaymentMethodDisabled = (paymentMethodName) => {
    const payLimit = getPayLimitRanger()?.[paymentMethodName];
    const amountLimit = getPaymentAmountLimit();

    if (amountLimit > payLimit?.payLimitMax)
      return {
        ...payLimit,
        amountLimit,
      };

    return false;
  };

  const checkPaymentMethodItemDisabled = (paymentMethod) => {
    if (paymentMethod === METHOD_PAYTO)
      return (
        (isArray(paytoAccountsAgreement) &&
          paytoAccountsAgreement?.some(
            (accountAgreement) => accountAgreement?.blocked
          )) ||
        isPaymentMethodDisabled(paymentMethod)
      );
    return isPaymentMethodDisabled(paymentMethod);
  };

  const renderPaymentMethodItem = (method) => {
    // if (isMobile || isTablet)
    //   return (
    //     <PaymentMethodItemMobile
    //       key={method.method}
    //       method={method}
    //       information={information}
    //       setInformation={setInformation}
    //       validation={validation}
    //       setValidation={setValidation}
    //       informationChangeBackup={informationChangeBackup}
    //       setInformationChangeBackup={setInformationChangeBackup}
    //       setOpenDiscountImportantPopup={setOpenDiscountImportantPopup}
    //       setOpenFxPaymentMethodOnChangePopup={
    //         setOpenFxPaymentMethodOnChangePopup
    //       }
    //       paymentMethodCache={paymentMethodCache}
    //       payLimit={getPayLimitRanger()?.[method.method]}
    //       isDisabled={isPaymentMethodDisabled(method.method)}
    //       isSelectRequired={isSelectRequired}
    //     />
    //   );

    return (
      <PaymentMethodItem
        key={method.method}
        method={method}
        information={information}
        setInformation={setInformation}
        validation={validation}
        setValidation={setValidation}
        informationChangeBackup={informationChangeBackup}
        setInformationChangeBackup={setInformationChangeBackup}
        setOpenDiscountImportantPopup={setOpenDiscountImportantPopup}
        setOpenFxPaymentMethodOnChangePopup={
          setOpenFxPaymentMethodOnChangePopup
        }
        paymentMethodCache={paymentMethodCache}
        payLimit={getPayLimitRanger()?.[method.method]}
        isDisabled={checkPaymentMethodItemDisabled(method.method)}
        isSelectRequired={isSelectRequired}
      />
    );
  };

  const renderNoticeSection = () => {
    return (
      <NoticeSection>
        <img src={NoticeIcon} width={50} height={41} />
        <p>{t('fx_add_transaction_pm_notice_desc')}</p>
      </NoticeSection>
    );
  };

  return (
    <>
      {renderNoticeSection()}
      <DescValidation
        $isError={validation[FX_ADD_TRANSACTION_PAYMENT_METHOD_NAME]}
      >
        {t('fx_add_transaction_choose_payment_method')}:
      </DescValidation>
      <PaymentMethodsGridStyled>
        {PAYMENT_METHODS.map((method) => (
          <Fragment key={method.method}>
            {renderPaymentMethodItem(method)}
          </Fragment>
        ))}
      </PaymentMethodsGridStyled>
    </>
  );
};

const PaymentMethodsGridStyled = styled.div`
  display: grid;
  grid-template-columns: calc(50% - 4px) calc(50% - 4px);
  flex-flow: wrap;
  grid-gap: 8px;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    display: flex;
    flex-flow: wrap;
    grid-gap: 24px;
  }
`;

const NoticeSection = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: var(--ds-c-yellow-light);
  border-radius: 8px;
  width: 100%;
  padding: 8px;
  margin-bottom: 8px;

  & p {
    ${paragraphMixin};
    font-size: 14px;
    line-height: 17px;
    font-weight: 500;
  }

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    width: 666px;
    margin-bottom: 20px;
  }
`;

export default PaymentMethodsGrid;
